import { useAppState } from 'hooks/useAppState';
import { Cache } from 'types/util';

export const useCompetitionsRequestsCount = (): Cache<number> => {
  const { competitionsRequestsCount } = useAppState();

  return competitionsRequestsCount;
};
